import {
	handleActions
} from 'redux-actions';
import Immutable from 'immutable';

const AuthState = Immutable.fromJS({
	roles: []
});

const authReducer = handleActions({
	FIND_AUTH_ROLES: (state, { payload }) => {
		return state.merge({
			roles: payload.data
		})
	}
}, AuthState);

export default authReducer;


// WEBPACK FOOTER //
// ./src/reducers/authReducer.js